import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.9-12.4a6 6 0 0 0 6 6A6 6 0 1 1 12.3 6a5.974 5.974 0 0 0-1.2 3.6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
